import type { PreviewKind, Resource, ResourceType } from './types';

export const mapFileTypeToResourceType = (value?: string): ResourceType => {
  const normalized = value?.toLowerCase() ?? '';
  if (normalized === 'pdf') {
    return 'PDF';
  }
  if (['image', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(normalized)) {
    return 'Image';
  }
  if (normalized === 'link') {
    return 'Link';
  }
  // Default to PDF for unrecognized types
  return 'PDF';
};

export const formatResourceDate = (value?: string) => {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

const getExtension = (value?: string) =>
  value?.split('.').pop()?.split('?')[0]?.toLowerCase() ?? '';

export const getPreviewKind = (resource: Resource): PreviewKind => {
  const extension = getExtension(resource.link);
  const isImage =
    resource.type === 'Image' ||
    ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension);
  const isDoc = ['doc', 'docx', 'odt', 'rtf'].includes(extension);
  const isPdf = resource.type === 'PDF' || extension === 'pdf';
  if (isImage) {
    return 'image';
  }
  if (isDoc) {
    return 'doc';
  }
  if (isPdf) {
    return 'pdf';
  }
  return 'none';
};
